import { getAssetPath } from '@/utils/helpers';

function setSrc(el, binding) {
  el.setAttribute('src', getAssetPath(binding.value));
}

export default {
  mounted(el, binding) {
    setSrc(el, binding);
  },
};
